import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import DataCacheService from '@/shared/services/DataCacheService';
import { LicenseQueryKey } from '@/shared/hooks/license/queryKey';
import { EmployeeQueryKey } from './queryKey';
const syncCurrentUserCache = (employee) => {
    const dataCache = DataCacheService.getDataCache();
    const current = dataCache === null || dataCache === void 0 ? void 0 : dataCache.employee;
    if (current && (employee === null || employee === void 0 ? void 0 : employee.employeeID) === current.employeeID) {
        Object.assign(current, employee);
    }
};
export const useUpdateEmployee = () => {
    const intl = useIntl();
    const queryClient = useQueryClient();
    const { mutateAsync, isLoading } = useMutation(model => api.base.put('/api/employee/PUT', model).then(res => res.data), {
        onSuccess: result => {
            if (result) {
                queryClient.setQueryData([EmployeeQueryKey.Employee, result.employeeID], (old) => {
                    var _a;
                    return (Object.assign(Object.assign({}, result), { employeeProfiles: (_a = result.employeeProfiles) !== null && _a !== void 0 ? _a : old === null || old === void 0 ? void 0 : old.employeeProfiles }));
                });
                syncCurrentUserCache(result);
                queryClient.invalidateQueries([LicenseQueryKey.Info]);
            }
        },
        onError: apiError => {
            handleHttpError(intl)(apiError);
        },
    });
    return { updateEmployee: mutateAsync, isLoading };
};
export const useUpdateEmployeeTeams = (employeeId) => {
    const intl = useIntl();
    const { mutateAsync, isLoading } = useMutation(teams => api.base
        .put(`/api/employee/UpdateEmployeeTeams?id=${employeeId}`, teams)
        .then(res => res.data), {
        onError: apiError => {
            handleHttpError(intl)(apiError);
        },
    });
    return { updateTeams: mutateAsync, isLoading };
};
export const useUpdateEmployeeTags = (employeeId) => {
    const intl = useIntl();
    const { mutateAsync, isLoading } = useMutation(tags => api.base
        .put(`/api/employee/tags?id=${employeeId}`, tags)
        .then(res => res.data), {
        onError: apiError => {
            handleHttpError(intl)(apiError);
        },
    });
    return { updateTags: mutateAsync, isLoading };
};
export const useUpdateInternalPrice = () => {
    const intl = useIntl();
    const { mutateAsync, isLoading } = useMutation(payload => api.base
        .put('/api/employee/updateInternalPrice', payload)
        .then(res => res.data), {
        onError: apiError => {
            handleHttpError(intl)(apiError);
        },
    });
    return { updateInternalPrice: mutateAsync, isLoading };
};
export const useResetTwoFa = () => {
    const intl = useIntl();
    const { mutateAsync, isLoading } = useMutation(userId => api.base.post(`/api/user/ResetTwoFa/${userId}`).then(res => res.data), {
        onError: apiError => {
            handleHttpError(intl)(apiError);
        },
    });
    return { resetTwoFa: mutateAsync, isLoading };
};
